// Parent view of a child's timetable: child selector + reused student schedule page.
import React, { useState } from 'react';
import MySchedulePage from '@/features/student/pages/MySchedulePage';
import { ChildSelector } from '../components/ChildSelector';

const ParentSchedulePage: React.FC = () => {
  const [childId, setChildId] = useState<string | null>(null);

  return (
    <div>
      <div className="px-6 pt-6">
        <ChildSelector onChildChange={setChildId} />
      </div>
      {childId && <MySchedulePage key={childId} studentId={childId} />}
    </div>
  );
};

export default ParentSchedulePage;
